module.exports = __webpack_public_path__ + "img/background-item1.3b2e69ea.png";